import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Radio, Input } from "antd";
import axios from "axios";
import { formatAuth, formatVipGrade } from "../../util/format";
import { sanitizeHtml } from "../../util/sanitizeHtml";

const TaskDetailModal = (props) => {
  const { title, visible, loading, footer, closeDialog, data } = props;
  const [type, setType] = useState("");
  const [content, setContent] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  const navigate = useNavigate();
  const toLogin = () => {
    navigate("/login");
  };

  if (title === "任务详情" && data && Object.keys(data).length) {
    return (
      <div>
        <Modal
          title={title}
          open={visible}
          onCancel={closeDialog}
          loading={loading}
          footer={footer}
        >
          <div className="modalF">
            <div>任务标题：{data.title}</div>
            <div>任务赏金：{data.money}</div>
            <div>是否紧急：{data.exigence == 0 ? "非紧急" : "紧急"}</div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>任务领域：{data.domain}</div>
              <div>
                难易程度：
                {data.complexity === "1"
                  ? "容易"
                  : data.complexity === "2"
                  ? "中等"
                  : "复杂"}
              </div>
            </div>
            <div>线上/线下：{data.type === "1" ? "线上" : "线下"}</div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>发布者：{data.nickName}</div>
              <div>ID：{data.number}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>实名认证：{formatAuth(data.auth)}</div>
              <div>会员等级：{formatVipGrade(data.vipGrade)}</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ width: "50%" }}>发布时间：{data.createTime}</div>
              <div>截止时间：{data.deadline}</div>
            </div>
            <div>完成地点：{data.offlineLocation}</div>
            <div>任务描述：<span dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.taskContent) }} /></div>
            <div>任务要求：{data.taskFeedback}</div>
          </div>
        </Modal>
      </div>
    );
  } else if (
    (title === "发布者申诉详情" || title === "接单者申诉详情") &&
    data &&
    data.length
  ) {
    return (
      <div>
        <Modal
          title={title}
          open={visible}
          onCancel={closeDialog}
          loading={loading}
          footer={footer}
        >
          <div className="modalF">
            {data.map((item) => (
              <div>
                <div>申诉时间：{item.appealTime}</div>
                <div>申诉内容：{item.appealContent}</div>
                {/* <div>申诉图片：{item.appealPics}</div> */}
              </div>
            ))}
          </div>
        </Modal>
      </div>
    );
  } else if (title === "仲裁") {
    const { TextArea } = Input;
    const onTypeChange = (e) => {
      setType(e.target.value);
    };
    const onContentChange = (e) => {
      setContent(e.target.value);
    };
    const handleOk = async () => {
      if (!content || !type) return;
      try {
        const token = localStorage.getItem("token");
        setBtnLoading(true);
        const res = await axios.post(
          "/api/taskAppeal/addAppealResult",
          {
            taskId: data.taskId,
            resultContent: content,
            resultType: type,
          },
          {
            headers: { "X-Access-Token": token },
          }
        );
        if (res.data.code == 401) {
          localStorage.clear();
          toLogin();
          return;
        }
        closeDialog();
      } catch (error) {
        console.error("请求失败:", error);
      } finally {
        setBtnLoading(false);
      }
    };
    return (
      <div>
        <Modal
          title={title}
          open={visible}
          onCancel={closeDialog}
          loading={loading}
          footer={[
            <Button key="back" onClick={closeDialog}>
              取消
            </Button>,
            <Button
              key="submit"
              disabled={!content || !type}
              loading={btnLoading}
              type="primary"
              onClick={handleOk}
            >
              确认
            </Button>,
          ]}
        >
          <div className="modalF">
            <div style={{ display: "flex" }}>
              <div style={{ padding: "10px 20px 20px 0" }}>仲裁结果：</div>
              <TextArea
                placeholder="客服备注说明"
                rows={4}
                onChange={onContentChange}
              />
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ padding: "10px 20px 20px 0" }}>仲裁理由：</div>
              <Radio.Group
                onChange={onTypeChange}
                value={type}
                className="radio1"
              >
                <Radio value={"1"}>重置为开始状态</Radio>
                <Radio value={"2"}>强制验收成功</Radio>
              </Radio.Group>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
};

export default TaskDetailModal;
